import React, { useEffect, useRef, useCallback } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

const springConfig = { damping: 25, stiffness: 250, mass: 0.5 };

export default function CustomCursor() {
  const dotX = useMotionValue(0);
  const dotY = useMotionValue(0);
  const ringX = useSpring(0, springConfig);
  const ringY = useSpring(0, springConfig);
  const ringScale = useSpring(1, { damping: 20, stiffness: 300 });
  const isTouch = useRef(false);
  const visible = useMotionValue(0);

  useEffect(() => {
    isTouch.current = window.matchMedia("(pointer: coarse)").matches;
    if (isTouch.current) return;

    const move = (e) => {
      dotX.set(e.clientX);
      dotY.set(e.clientY);
      ringX.set(e.clientX);
      ringY.set(e.clientY);
      visible.set(1);
    };

    const handleEnter = (e) => {
      const target = e.target;
      if (
        target.closest("a") ||
        target.closest("button") ||
        target.closest(".cursor-hover") ||
        target.closest("input") ||
        target.closest("textarea")
      ) {
        ringScale.set(1.8);
      }
      if (target.closest(".cursor-expand")) {
        ringScale.set(2.5);
      }
    };

    const handleLeave = () => {
      ringScale.set(1);
    };

    const handleMouseLeave = () => {
      visible.set(0);
    };

    const handleMouseEnter = () => {
      visible.set(1);
    };

    window.addEventListener("mousemove", move, { passive: true });
    document.addEventListener("mouseover", handleEnter, { passive: true });
    document.addEventListener("mouseout", handleLeave, { passive: true });
    document.documentElement.addEventListener("mouseleave", handleMouseLeave);
    document.documentElement.addEventListener("mouseenter", handleMouseEnter);

    return () => {
      window.removeEventListener("mousemove", move);
      document.removeEventListener("mouseover", handleEnter);
      document.removeEventListener("mouseout", handleLeave);
      document.documentElement.removeEventListener(
        "mouseleave",
        handleMouseLeave,
      );
      document.documentElement.removeEventListener(
        "mouseenter",
        handleMouseEnter,
      );
    };
  }, [dotX, dotY, ringX, ringY, ringScale, visible]);

  if (
    typeof window !== "undefined" &&
    window.matchMedia("(pointer: coarse)").matches
  ) {
    return null;
  }

  return (
    <>
      <motion.div
        className="cursor-dot"
        style={{ x: dotX, y: dotY, opacity: visible }}
      />
      <motion.div
        className="cursor-ring"
        style={{ x: ringX, y: ringY, scale: ringScale, opacity: visible }}
      />
    </>
  );
}
